/**
 * config file for admin-cli projects
 *
 */
export const language_codes = [
  {
    name: 'English',
    TEXT: 'English', // admin字段需要
    value: 'en',
    F_LANG: 'en', // admin字段需要
    data: 'en_US', // 用作前后端交互数据
    eventName: 'EN'
  },
  {
    name: '简体中文',
    TEXT: '简体中文',
    value: 'zh-CN',
    F_LANG: 'zh-CN',
    data: 'zh_CN',
    eventName: 'ZH-CN'
  },
  {
    name: '繁體中文',
    TEXT: '繁體中文',
    value: 'zh-TW',
    F_LANG: 'zh-TW',
    data: 'zh_TW',
    eventName: 'ZH-TW'
  },
  {
    name: '日本語',
    TEXT: '日本語',
    value: 'ja',
    F_LANG: 'ja',
    data: 'ja_JP',
    eventName: 'JA'
  },
  {
    name: '한국어',
    TEXT: '한국어',
    value: 'ko',
    F_LANG: 'ko',
    data: 'ko_KR',
    eventName: 'KO'
  },
  {
    name: 'ไทย',
    TEXT: 'ไทย',
    value: 'th',
    F_LANG: 'th',
    data: 'th_TH',
    eventName: 'TH'
  }
]

export const admin_language_codes = [
  {
    name: 'English',
    TEXT: 'English', // admin字段需要
    value: 'en',
    F_LANG: 'en', // admin字段需要
    data: 'en_US', // 用作前后端交互数据
    eventName: 'EN'
  },
  {
    name: '简体中文',
    TEXT: '简体中文',
    value: 'zh-CN',
    F_LANG: 'zh-CN',
    data: 'zh_CN',
    eventName: 'ZH-CN'
  },
  {
    name: '繁體中文',
    TEXT: '繁體中文',
    value: 'zh-TW',
    F_LANG: 'zh-TW',
    data: 'zh_TW',
    eventName: 'ZH-TW'
  }
]

export const merchant_language_codes = [
  {
    name: 'English',
    value: 'en',
    data: 'en_US', // 用作前后端交互数据
    eventName: 'EN'
  },
  {
    name: '简体中文',
    value: 'zh-CN',
    data: 'zh_CN',
    eventName: 'ZH-CN'
  },
  {
    name: '繁體中文',
    value: 'zh-TW',
    data: 'zh_TW',
    eventName: 'ZH-TW'
  },
  {
    name: '日本語',
    value: 'ja',
    data: 'ja_JP',
    eventName: 'JA'
  },
  {
    name: '한국어',
    value: 'ko',
    data: 'ko_KR',
    eventName: 'KO'
  },
  {
    name: 'ไทย',
    value: 'th',
    data: 'th_TH',
    eventName: 'TH'
  }
]

// https://knpm.klook.io/-/web/detail/@klook/admin-layout
export const layout_options = {
  navbarStyle: 'left', // 导航风格，可选值为：'left', 'top'
  isSubSidebarOpen: true // 二级导航是否打开
}

export const merchant_layout_options = {
  navbarStyle: 'left', // 导航风格，可选值为：'left', 'top'
  isSubSidebarOpen: true // 二级导航是否打开
}
